import { Medium, SemiBold } from '@src/apps/styles/common-style';
import styled from 'styled-components';

export const styles = {
  chevronIcon: {
    width: '12px',
    height: '7px',
    background: '#196ECF',
    transform: 'matrix(0, 1, 1, 0, 0, 0)',
  },
};

export const FaqContainerStyle = styled('div')<{
  fontFamily?: string;
}>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 8px;
  gap: 36px;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 1;

  .main-title {
    width: 100%;
    font-family: ${(props) => props.fontFamily || SemiBold};
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    color: #2d2d39;
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
  }

  .categories-section {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px 0px 36px;
    gap: 36px;
    width: 100%;
    min-height: auto;
    border-bottom: 1px solid #e0e0e0;
    flex: none;
    order: 1;
    align-self: stretch;
    flex-grow: 0;
  }

  .question-state {
    width: 100%;
    position: relative;
  }

  .category-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0px;
    gap: 8px;
    cursor: pointer;
  }

  .category-text {
    font-family: ${(props) => props.fontFamily || SemiBold};
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    color: #196ecf;
    flex: none;
    order: 0;
    flex-grow: 0;
  }

  .chevrons {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0px;
    gap: 8px;
    width: 7px;
    height: 12px;
    flex: none;
    order: 1;
    flex-grow: 0;
  }

  .chevron-vector {
    width: 12px;
    height: 7px;
    background: #196ecf;
    transform: matrix(0, 1, 1, 0, 0, 0);
    flex: none;
    order: 0;
    flex-grow: 0;
  }

  .questions-list {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    gap: 24px;
    width: 100%;
    min-height: 200px;
    flex: none;
    order: 1;
    align-self: stretch;
    flex-grow: 0;
  }

  .question-item {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px 1px 24px;
    gap: 10px;
    width: 100%;
    min-height: 36px;
    border-bottom: 1px solid #e0e0e0;
    flex: none;
    align-self: stretch;
    flex-grow: 0;
    position: relative;

    &.expanded {
      min-height: auto;
    }
  }

  .question-text {
    font-family: ${(props) => props.fontFamily || SemiBold};
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    color: #196ecf;
    cursor: pointer;
  }

  .question-item.expanded .question-text {
    font-weight: 600;
    color: #196ecf;
  }

  .answer-text {
    width: 100%;
    font-family: ${(props) => props.fontFamily || Medium};
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    color: #2d2d39;
  }

  .more-info-button {
    width: 180px;
    height: auto;
    font-family: ${(props) => props.fontFamily || SemiBold};
    font-size: 14px;
    line-height: 14px;
    color: #196ecf;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
    text-align: left;
  }

  .bottom-section,
  .bottom-section-mostcommon,
  .bottom-section-category {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    gap: 36px;
    width: 100%;
    flex: none;
    order: 2;
    align-self: stretch;
    flex-grow: 0;
  }

  .common-questions-header,
  .common-questions-link,
  .all-categories-link {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0px;
    gap: 8px;
    cursor: pointer;
  }

  .common-questions-text,
  .all-categories-link-text {
    font-family: ${(props) => props.fontFamily || SemiBold};
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    color: #196ecf;
    flex: none;
    order: 0;
    flex-grow: 0;
  }

  .contact-us-section {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 36px 0px 0px;
    gap: 16px;
    width: 100%;
    flex: none;
    order: 1;
    align-self: stretch;
    flex-grow: 0;
  }

  .more-questions-section {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    gap: 16px;
    width: 100%;
    flex: none;
    order: 1;
    align-self: stretch;
    flex-grow: 0;
  }

  .more-questions-title {
    font-family: ${(props) => props.fontFamily || SemiBold};
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    color: #2d2d39;
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
  }

  .contact-us-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0px;
    gap: 8px;
    cursor: pointer;
  }

  .contact-us-text {
    font-family: ${(props) => props.fontFamily || SemiBold};
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    color: #196ecf;
    flex: none;
    order: 0;
    flex-grow: 0;
  }
`;
